"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigationLinks = [{
    label: "Home",
    to: "/HomePage"
  }, {
    label: "Solutions",
    to: "#"
  }, {
    label: "How It Works",
    to: "#"
  }, {
    label: "Testimonials",
    to: "#"
  }, {
    label: "FAQ",
    to: "#"
  }, {
    label: "Contact",
    to: "https://armywritingtools.com/contact-us/"
  }];
  const socialLinks = [{
    icon: Facebook,
    label: "Facebook",
    to: "#"
  }, {
    icon: Twitter,
    label: "Twitter",
    to: "#"
  }, {
    icon: Linkedin,
    label: "LinkedIn",
    to: "#"
  }, {
    icon: Instagram,
    label: "Instagram",
    to: "#"
  }];
  return <footer className="bg-dark-background text-foreground-dark py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-8 items-center mb-8">
          {}
          <nav className="grid grid-cols-2 sm:grid-cols-3 gap-3 items-center justify-items-center max-w-fit mx-auto">
            {navigationLinks.map((link, i) => <Link key={i} to={link.to} data-index={i} className="text-sm text-white border border-white/30 rounded-md px-4 py-2 hover:bg-white/10 hover:border-white hover:text-white transition-colors duration-[var(--duration-medium)] relative group w-full text-center">
                {link.label}
              </Link>)}
          </nav>

          {}
          <div className="flex items-center justify-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={i} to={social.to} data-index={i} aria-label={social.label} className="text-foreground hover:text-foreground transition-colors duration-[var(--duration-medium)] relative group">
                  <Icon className="size-5" />
                  <span className="absolute left-0 bottom-0 w-0 h-px bg-foreground-dark transition-all duration-[var(--duration-medium)] group-hover:w-full" />
                </Link>;
          })}
          </div>
        </div>

        {}
        <div className="flex items-center justify-center">
          <p className="text-sm text-white text-center">
            © {currentYear} Army Writing Tools · Built by Army leaders · Not affiliated with the U.S. Army or DoD
          </p>
        </div>
      </div>
    </footer>;
}